import {useQuery} from "@tanstack/react-query";
import {getData} from "../../../app/getters/getData.js";
const INTERVAL_CHECK_REPORT_READY = 1500


export const useStatusRaportu= (uuid, isChecking, prefix = 'oper') => {
    return useQuery({
        queryKey: [`raport_ready__${uuid}`],
        queryFn: () => getData(`${prefix}/raporty/status/${uuid}`),
        refetchInterval: INTERVAL_CHECK_REPORT_READY,
        enabled: isChecking && !!uuid,
    })
}